import React, { useState } from "react";
import "../styles/Skills.css";

// skills
const languages = [`HTML`, `CSS/SaSS`, `JavaScript`, `TypeScript`, `Python`, `PHP`, `SQL`];
const frameworks = [`ReactJS`, `React Native`, `AngularJS`, `jQuery`, `Node.JS`, `Express`, `Bootstrap`];
const databases = [`Postgres SQL`, `MySQL`, `MongoDB`, `Firebase`];
const platforms = [`Firebase`, `AWS`, `Azure`, `Git`, `WordPress`, `Shopify`,];
const tools = [`VS Code`, `Postman`, `Figma`, `Adobe XD`, `Photoshop`, `Illustrator`, `Jira`, `Trello`, `Slack`, `Zoom`, `Google Meet`, `Microsoft Teams`, `Discord`];

function Skills() {
  const [showSkills, setShowSkills] = useState(languages);

  const Cbtn = ({ skills, category }) => {
    return (
      <button className="skills__menuButton" onClick={() => setShowSkills(skills)}>
        {category}
      </button>
    );
  };

  return (
    <div className="skills__wrapper" id="skills">

      {/* SKILLS */}
      <p className="skills__title">Explore Skills</p>

      <div style={{ display: 'flex', justifyContent: 'center' }} className="container">

        {/* Menu */}
        <div className="skills__listMenu">
          <Cbtn skills={languages} category="Languages" />
          <Cbtn skills={frameworks} category="Frameworks" />
          <Cbtn skills={databases} category="Databases" />
          <Cbtn skills={platforms} category="Platforms" />
          <Cbtn skills={tools} category="Tools" />
        </div>
        <div className="divider" />
        {/* Container */}
        <div className="skills__listSkills">
          {showSkills.map((skill, index) => (
            <div key={index} className="skills__item">
              <p>{skill}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Skills;
